import { useContext } from 'react';
import { PopupContext } from './PopupContext';

const usePopup = () => {
  const { popupId, setPopupId } = useContext(PopupContext) || {};
  return { popupId, setPopupId };
};

export default usePopup;
